import { AnonymousStudentInitializer } from './infrastructure/anonymous-student-initializer';

const initializer = new AnonymousStudentInitializer();
initializer.initialize();
